







export default {
  name: 'ChatFilledIcon',
  props: {
    color: {
      type: String,
      default: '#171717'
    }
  }
}
